"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePageData = void 0;
var react_1 = __importStar(require("react"));
var OneApplication_1 = require("~clients/OneApplication");
var OneProduct_1 = require("~clients/OneProduct");
var PageDataContext = react_1.default.createContext({
    sections: {},
    sectionName: function (section) { return ''; },
    sectionLabel: function (section, key) { return ''; },
    sectionTitle: function (section) { return ''; },
    sectionKeys: function (section) { return ({}); },
    sectionsData: function (section) { return []; },
    isLoading: false,
    isProductLoaded: {},
    products: {},
    hasError: false
});
var usePageData = function () { return react_1.default.useContext(PageDataContext); };
exports.usePageData = usePageData;
/**
 * @category Context
 */
var PageDataContextProvider = function (_a) {
    var children = _a.children;
    /* States */
    var _b = (0, react_1.useState)({}), appData = _b[0], setAppData = _b[1];
    var _c = (0, react_1.useState)({}), products = _c[0], setProducts = _c[1];
    var _d = (0, react_1.useState)(true), isProductsLoading = _d[0], setProductsLoading = _d[1];
    var _e = (0, react_1.useState)(true), isDataLoading = _e[0], setDataLoading = _e[1];
    var _f = (0, react_1.useState)(false), isInitialzied = _f[0], setIsInitialized = _f[1];
    var _g = (0, react_1.useState)(false), hasError = _g[0], setHasError = _g[1];
    var loadCachedData = function (model) {
        if (model.cached_url) {
            (0, OneProduct_1.getCachedJson)(model.cached_url)
                .then(function (product) {
                setProducts(function (old) {
                    var _a;
                    return (__assign(__assign({}, old), (_a = {}, _a[model.name] = product, _a)));
                });
            })
                .catch(function (e) { return console.log(e); });
        }
    };
    (0, react_1.useEffect)(function () {
        if (!isInitialzied) {
            setIsInitialized(true);
            setProductsLoading(true);
            (0, OneProduct_1.getAllProducts)('en')
                .then(function (response) {
                if (response.success) {
                    var newProducts_1 = {};
                    response.data.forEach(function (product) { return (newProducts_1[product.name] = product); });
                    setProducts(newProducts_1);
                    response.data.forEach(function (model) { return loadCachedData(model); });
                }
                else {
                    setHasError(true);
                }
            })
                .catch(function (error) {
                console.log(error);
                setHasError(true);
            })
                .finally(function () {
                setProductsLoading(false);
            });
            setDataLoading(true);
            (0, OneApplication_1.getAppData)('en')
                .then(function (response) {
                if (response.success) {
                    var newSections_1 = {};
                    response.data.sections.forEach(function (section) {
                        newSections_1[section.section_name] = section;
                    });
                    setAppData(newSections_1);
                }
                else {
                    setHasError(true);
                }
            })
                .catch(function (error) {
                setHasError(true);
                console.log(error);
            })
                .finally(function () {
                setDataLoading(false);
            });
        }
    }, [isInitialzied]);
    var isProductLoaded = {};
    Object.keys(products).forEach(function (key) { var _a; return (isProductLoaded[key] = !!((_a = products[key]) === null || _a === void 0 ? void 0 : _a.cached_url)); });
    var value = (0, react_1.useMemo)(function () { return ({
        sections: appData,
        sectionName: function (section) { var _a; return ((_a = appData[section]) === null || _a === void 0 ? void 0 : _a.section_name_localized) || ''; },
        sectionLabel: function (section, key) { var _a; return ((_a = appData[section]) === null || _a === void 0 ? void 0 : _a.key_values[key]) || ''; },
        sectionTitle: function (section) { var _a; return ((_a = appData[section]) === null || _a === void 0 ? void 0 : _a.section_name_localized) || ''; },
        sectionKeys: function (section) { var _a; return ((_a = appData[section]) === null || _a === void 0 ? void 0 : _a.key_values) || ''; },
        sectionsData: function (section) {
            var keys = Object.keys(appData).filter(function (k) { return k.startsWith(section); });
            return keys.map(function (k) { return appData[k].key_values; });
        },
        isLoading: isDataLoading || isProductsLoading,
        isProductLoaded: isProductLoaded,
        products: products,
        hasError: hasError
    }); }, [appData, isDataLoading, isProductsLoading, hasError, products]);
    return react_1.default.createElement(PageDataContext.Provider, { value: value }, children);
};
exports.default = PageDataContextProvider;
